/** Implement a custom <table> component that renders rows with checkboxes */
import React from 'react';
import immutable from 'immutable';

const trStyle = immutable.Map({
  height: '38px',
  borderBottom: '1px solid #E4E8EC',
});
const thStyle = immutable.Map({
  paddingLeft: '10px',
  paddingRight: '10px',
});
const thSpanStyle = immutable.Map({
  display: 'block',
  textAlign: 'center',
  margin: '0 auto',
});
const tdCellStyle = immutable.Map({
  textAlign: 'center',
});
const tdStyle = immutable.Map({});

class TableWithCheckBoxRows extends React.Component {
  render() {
    const data = immutable.List(this.props.data);
    return (
      <table className="table-with-checkbox plain-border" ref={this.props.tableRef}>
        <thead>
          <tr style={trStyle.toObject()} key="header">
            {this.props.columns
              .map(header => {
                const style = thStyle.merge(header.style);
                const spanStyle = thSpanStyle.merge(header.spanStyle);
                return (
                  <th key={header.id} style={style.toObject()}>
                    <span style={spanStyle.toObject()}>{header.Header}</span>
                  </th>
                );
              })
              .toArray()}
          </tr>
        </thead>
        <tbody>
          {data.map(item => {
            return (
              <tr style={trStyle.toObject()} key={item.id}>
                {this.props.columns.map(header => {
                  const value = item[header.accessor];
                  const style = tdStyle.merge(header.tdStyle);
                  const headerStyle = tdCellStyle.merge(header.tdCellStyle);
                  return (
                    <td style={style.toObject()} key={header.id}>
                      {header.cell({
                        value: value,
                        style: headerStyle.toObject(),
                        spanStyle: {lineHeight: '38px'},
                        iconStyle: {lineHeight: '38px'},
                        original: item,
                        column: header,
                      })}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default TableWithCheckBoxRows;
